let isTurning = false;
let interval;
var button;
let timeout;
let timeoutOn = false;

var imageHandle360 = {
    index: 0,
    imgElement: null,
    images: [],
    init: function () {
        var element = document.getElementById("product-figure");
        button = document.getElementById("product-figure-playbutton");
        for (var index in image360) {
            var img = document.createElement("IMG");
            img.src = image360[index];
            imageHandle360.images.push(img);
            img.style.display = (index === 0) ? "" : "none";
            element.appendChild(img);
        }
        imageHandle360.animate();
        element.addEventListener("click", function () {imageHandle360.TurnImage()});
        button.addEventListener("click", function () { imageHandle360.StartStop()});
        button.classList.toggle("play");
    },

    animate: function () {
        isTurning = true;
        interval = setInterval(function () {
            var lastIndex = imageHandle360.index === 0 ? imageHandle360.images.length - 1 : imageHandle360.index - 1;
            imageHandle360.images[lastIndex].style.display = "none";
            imageHandle360.images[imageHandle360.index].style.display = "";
            imageHandle360.index = (imageHandle360.index + 1) % imageHandle360.images.length;
        }, 200);
        timeoutOn = true;
        timeout = setTimeout(function() { 
            isTurning = false;
            button.classList.toggle("play");
            clearInterval(interval);
        }, imageHandle360.images.length * 400);
    },

    StartStop: function () {
        if(timeoutOn) {
            timeoutOn = false;
            clearTimeout(timeout);
        } if(!isTurning) {
            button.classList.toggle("play");
            interval = setInterval(function () {
                var lastIndex = imageHandle360.index === 0 ? imageHandle360.images.length - 1 : imageHandle360.index - 1;
                imageHandle360.images[lastIndex].style.display = "none";
                imageHandle360.images[imageHandle360.index].style.display = "";
                imageHandle360.index = (imageHandle360.index + 1) % imageHandle360.images.length;
            }, 200);
        } if(isTurning) {
            clearInterval(interval);
            button.classList.toggle("play");
        }
        return(
            isTurning = !isTurning
        )
    },

    TurnImage: function () {
        var lastIndex = imageHandle360.index === 0 ? imageHandle360.images.length - 1 : imageHandle360.index - 1;
        imageHandle360.images[lastIndex].style.display = "none";
        imageHandle360.images[imageHandle360.index].style.display = "";
        imageHandle360.index = (imageHandle360.index + 1) % imageHandle360.images.length;
    },


};
$(document).ready(function () {
    if (typeof image360 !== 'undefined') {
        imageHandle360.init();
    }
});